import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "./colors";
import { Heading5, Heading6 } from "./Text";
import EmptyStatus from "../../modules/extension/components/common/EmptyStatus";
import ButtonWithText from "./Button";
import ExpandingBox from "./ExpandingBox";
import FeatherIcon from "feather-icons-react";
import { Spinner } from "react-bootstrap";

//todo: 0.875 rem  yerine 28. satırda başka bir font-size kullanıldı (content ve right content)
//todo: rightcontent'de #00856C olmadığından başka renk kullanıldı TEKİN: #00856A olan success.900 kullanılabilir.
//todo: 1 rem olmadığı için heading5 kullanıldı
const ActionBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 24px;
    // position: absolute;
    right: 0;
    bottom: 0;
    // visibility: hidden;
    // opacity: 0;
    // transform: translateY(100%);
    transition: all 0.2s ease-in-out;
    padding: 8px 12px;
    border-top: 1px solid ${colors.neutral[100]};
    height: 40px;
    background-color: #fff;
    z-index: 10;
    border-radius: 0 0 6px 6px;
    width: 100%;
`;

const CardContainer = styled.div`
    background-color: ${({ variant }) =>
        variant === "borderless" || variant === "only-hr" ? "none" : "rgb(250, 250, 250)"};
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    border: ${({ variant }) =>
        variant === "borderless" || variant === "only-hr" ? "none" : `1px solid ${colors.neutral[100]}`};
    box-shadow: ${({ variant }) =>
        variant === "borderless" || variant === "only-hr" ? "none" : "0px 0px 1px 0px rgba(0, 0, 0, 0.2)"};
    padding: 0px 8px;
    ${({ variant }) => (variant === "courses-card" ? "margin-bottom: 8px;" : "margin: 8px 0px;")}
    position: relative;
    overflow: visible;
`;

/*const StyledCardContent = styled(Heading6)`
    color: ${colors.neutral[800]};
    letter-spacing: -0.17px;
`;
const StyledFooter = styled(Body2)`
    color: ${colors.neutral[800]};
    margin-top: 4px;
`;*/
const StyledContentWrapper = styled.div`
    /* border-bottom: ${({ isLast, variant }) =>
        isLast || variant === "borderless" ? "none" : `1px solid ${colors.neutral[100]}`}; */
    display: flex;
    flex-direction: column;
    width: ${({ variant }) => (variant === "courses-card" ? "calc(100% - 48px)" : "100%")}; 
    gap: ${({ variant }) =>
        variant === "detailPage" || variant === "courses-card" || variant === "notes-card" ? "8px" : "0px"};
    ${({ variant }) => variant === "notes-card" && "overflow: hidden;"}
`;
/*const StyledTitle = styled(Body2)`
    color: ${colors.neutral[800]};
    margin-bottom: 4px;
`;*/
const StyledIconContainer = styled.div`
    min-width: ${({ iconWidth }) => iconWidth ?? "24px"};
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const StyledButtonContainer = styled.div`
    //margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;
const ViewMoreButton = styled(Heading6)`
    color: ${colors.l3rnTech[900]};
    cursor: pointer;
    //margin-top: 8px;
    display: block;
`;

/*const StyledRightContent = styled(Heading6)`
    color: ${colors.success[800]};
    letter-spacing: -0.17px;
`;*/

export const StyledImageBox = styled("img")`
    width: 40px;
    height: 40px;
    border-radius: 4px;
`;
const StyledCardTitle = styled(Heading5)`
    color: ${colors.neutral[600]};
    display: block;
    width: 100%;
    cursor: ${(props) => (props.isLink ? "pointer" : "default")};
    &:hover {
        color: ${(props) => (props.isLink ? colors.l3rnTech[900] : colors.neutral[600])};
        text-decoration: ${(props) => (props.isLink ? "underline" : "none")};
    }
`;
export const StyledCollapseIcon = styled("div")`
    cursor: pointer;
    color: ${colors.neutral[600]};
    display: flex;
`;
const StyledCardItem = styled("div")`
    padding: ${({ variant }) => (variant === "only-hr" ? "16px 0px" : "8px 0px")};
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    overflow: visible;
    transition: padding-bottom 0.2s ease-in-out;

    ${({ onClick }) => onClick && "cursor: pointer;"}

    ${({ showDelete }) =>
        showDelete &&
        `
        &:hover {
            padding-bottom: 40px;

            .action-bar {
                visibility: visible;
                opacity: 1;
                transform: translateY(0);
            }
        }
    `}

    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: ${({ iconWidth }) => (iconWidth === "0px" || iconWidth === 0 ? "0px" : "36px")};
        right: 0;
        height: 1px;
        background-color: ${colors.neutral[200]};
        display: ${({ isLast, variant }) =>
            isLast || (variant !== "only-hr" && variant === "borderless") ? "none" : "block"};
    }
`;
const StyledInputContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    margin-top: 12px;
`;
// export const AnimatedCollapse = styled.div`
//     overflow: hidden;
//     transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//     max-height: ${({ collapsed }) => (collapsed ? "0px" : "850px")};
//     will-change: max-height;
// `;
const ExtensionCard = ({
    iconWidth,
    cardTitle,
    cardTitleOnClick,
    cardItems,
    button,
    viewMoreOnClick,
    key,
    haveViewMore = true,
    variant,
    input,
    errorDescription,
    isShowInput,
    showDelete = false,
    component,
    minVisibleItems = 3,
    collapsed = false,
    onCollapseChange,
    taskPage,
    content,
    homePage,
    isLoading,
}) => {
    const [viewMore, setViewMore] = useState(false);
    const visibleItems = cardItems ? (!haveViewMore || viewMore ? cardItems : cardItems.slice(0, 3)) : [];

    return (
        <div key={key}>
            <ExtensionCardHeader
                homePage={homePage}
                content={content}
                cardTitle={cardTitle}
                button={button}
                cardTitleOnClick={cardTitleOnClick}
                collapsed={collapsed}
                setCollapsed={onCollapseChange}
                taskPage={taskPage}
            />
            {/* <AnimatedCollapse collapsed={collapsed}> */}

            <>
                {!collapsed && (
                    <>
                        {!isLoading && component}
                        {isShowInput && <StyledInputContainer>{input}</StyledInputContainer>}
                        {isLoading ? (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                    padding: "12px",
                                }}
                            >
                                <Spinner animation="border" variant="l3rnTech" />
                            </div>
                        ) : visibleItems.length > 0 ? (
                            <CardContainer variant={variant}>
                                {visibleItems.map((cardItem, index) => (
                                    <ExtensionCardItem
                                        key={cardItem.id ? cardItem.id : index}
                                        variant={variant}
                                        iconWidth={iconWidth}
                                        cardItem={cardItem}
                                        index={index}
                                        isLast={index === visibleItems.length - 1}
                                        showDelete={showDelete && !!cardItem.onDelete}
                                        onClick={cardItem.onClick}
                                    />
                                ))}
                            </CardContainer>
                        ) : (
                            <EmptyStatus description={errorDescription} />
                        )}
                        {cardItems?.length > minVisibleItems && haveViewMore && !isLoading && (
                            <ViewMoreButton
                                onClick={() => (viewMoreOnClick ? viewMoreOnClick() : setViewMore(!viewMore))}
                            >
                                {viewMore ? "View Less" : "View More"}
                            </ViewMoreButton>
                        )}
                    </>
                )}
            </>

            {/* </AnimatedCollapse> */}
        </div>
    );
};

export const ExtensionCardHeader = ({
    cardTitle,
    button,
    cardTitleOnClick,
    collapsed,
    setCollapsed,
    homePage,
    content,
}) => {
    return (
        <StyledButtonContainer>
            <div
                style={{
                    display: "flex",

                    alignItems: "center",
                    gap: 8,
                }}
            >
                {homePage && (
                    <StyledCollapseIcon onClick={() => setCollapsed && setCollapsed(!collapsed)}>
                        {collapsed ? (
                            <FeatherIcon icon="chevron-down" size={17} />
                        ) : (
                            <FeatherIcon icon="chevron-up" size={17} />
                        )}
                    </StyledCollapseIcon>
                )}
                <StyledCardTitle isLink={!!cardTitleOnClick} onClick={cardTitleOnClick}>
                    {cardTitle}
                </StyledCardTitle>
            </div>
            {button}
        </StyledButtonContainer>
    );
};
export const ExtensionCardInput = ({ cardItem, index, isShowInput }) => {
    return (
        <div style={{ display: isShowInput ? "block" : "none" }} key={index}>
            {cardItem.input}
        </div>
    );
};

export const ExtensionCardItem = ({ variant, cardItem, iconWidth, index, isLast, showDelete, onClick }) => {
    const hideIcon = iconWidth === "0px" || iconWidth === 0;

    return (
        <ExpandingBox
            key={index}
            footerHeight="40px"
            footer={
                showDelete ? (
                    <ActionBar>
                        <ButtonWithText
                            size="small"
                            variant="danger"
                            buttonStyle="borderless"
                            onClick={cardItem.onDelete}
                        >
                            Delete
                        </ButtonWithText>
                    </ActionBar>
                ) : null
            }
        >
            <StyledCardItem
                variant={variant}
                isLast={isLast}
                showDelete={false}
                onClick={onClick}
                iconWidth={iconWidth}
            >
                {!hideIcon && (
                    <StyledIconContainer iconWidth={iconWidth}>
                        {cardItem.icon ? (
                            cardItem.icon
                        ) : cardItem.customImage ? (
                            cardItem.customImage
                        ) : cardItem.imgSrc ? (
                            <StyledImageBox alt={cardItem.imgSrc} src={cardItem.imgSrc} />
                        ) : (
                            ""
                        )}
                    </StyledIconContainer>
                )}
                <StyledContentWrapper variant={variant} isLast={isLast}>
                    {cardItem.header && cardItem.header}
                    {cardItem.content && cardItem.content}
                    {cardItem.footer && cardItem.footer}

                    {/*{cardItem.title && <StyledTitle>{cardItem.title}</StyledTitle>}
                <div className="d-flex justify-content-between align-items-center">
                    {cardItem.content && <StyledCardContent>{cardItem.content}</StyledCardContent>}
                    {cardItem.rightContent && <StyledRightContent>{cardItem.rightContent}</StyledRightContent>}
                </div>
                {cardItem.footer && <StyledFooter>{cardItem.footer}</StyledFooter>}*/}
                </StyledContentWrapper>
            </StyledCardItem>
        </ExpandingBox>
    );
};

export default ExtensionCard;
